import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import ActiveBannerUpdateConsent from './activeBannerUpdate';
import Airports from './airports';
import AirportsLite from './airportslite';
import AmaiaChat from './amaia-chat-reducer';
import Ancillaries from './ancillaries';
import AncillaryMyb from './ancillaryMyb';
import BaggageRedemption from './baggageRedemption';
import billingData from './billing/billingData';
import brandedBenefits from './branded-benefits-reducer';
import Booker from './booking/booker-reducer';
import CbxModal from './cbx/cbx-reducer';
import checkinReservation from './checkin-reservation-reducer';
import CobrandAffiliate from './cobrandAffiliate';
import countErrorPayment from './countErrorPayment';
import Countries from './countries';
import ElectronicVisa from './electronicVisa';
import EmailReducer from './emailReducer';
import EMDVoucherCompensation from './emdVoucherCompensation';
import ErrorMessage from './error-message';
import FormOfPayments from './formOfPayments';
import fulfillRefund from './fulfillRefund';
import infoForPurchaseMetric from './infoForPurchaseMetric';
import InteractionStudio from './interactionStudio';
import IropsElegibility from './irops';
import jwt from './jwt-reducer';
import LanguageBundle from './languageBundle';
import Login from './login';
import Manage from './manage';
import MealPreselectFlights from './mealPreselectFlights';
import MenuPromotions from './menu-promotions';
import MybMigrationDocs from './mybMigrationDocs';
import PantheonData from './pantheonData';
import PersonalizedAcquisition from './personalized-acquisition-cobrand';
import PopUpPersonalization from './singup_popup_personalization';
import PriorityList from './priorityList';
import ProfileLogin from './profile/profileLoginReducer';
import quoteRefund from './quoteRefund';
import reducerQuantityAdults from './reducerQuantityAdults';
import reducerQuantityInfants from './reducerQuantityInfants';
import reducerQuantityKids from './reducerQuantityKids';
import SeatMapBanner from './seatMapBanner';
import ScheduleChange from './schedule_change';
import SeatFare from './seat-fares';
import singleBilling from './billing/singleBilling';
import stampingBilling from './billing/stampingBilling';
import StoreFront from './storeFront';
import TouchPointsLogin from './touchpoints-login';
import TouchPointCpProperty from './touchPointCp';
import TravelInformation from './travel-information';
import tokenInvalidSecurity from './token-invalid-security';
import pendingOpenModalLogin from './pending-open-modal-login';
import UpgradeVoucher from './reducerUpgradeVoucher';
import UserProfileSession from './profile-session';
import UserProfileSessionMicro from './profile-session-micro';
import SessionValidation from './session-Validation';
import ToastReducer from './toast';
import Corporate from './corporate/index';
import refundReason from './refund-reason';
import refundCode96Dot5 from './refund-code-96-5';
import refundGticketList from './refund-g-ticket-list';
import refundInfoToSalesforce from './refundInfoToSalesforce';
import refundPassengerList from './refund-passenger-list';
import { openModalLogin, modalLoginMethod } from '../reducers/openModalLogin';
import { openModalSignUp, modalSignUpMethod } from '../reducers/openModalSignUp';

export default combineReducers({
  ActiveBannerUpdateConsent,
  Airports,
  AirportsLite,
  AmaiaChat,
  Ancillaries,
  AncillaryMyb,
  BaggageRedemption,
  billingData,
  brandedBenefits,
  Booker,
  CbxModal,
  checkinReservation,
  CobrandAffiliate,
  Corporate,
  countErrorPayment,
  Countries,
  ElectronicVisa,
  EmailReducer,
  EMDVoucherCompensation,
  ErrorMessage,
  form,
  FormOfPayments,
  fulfillRefund,
  infoForPurchaseMetric,
  InteractionStudio,
  IropsElegibility,
  jwt,
  LanguageBundle,
  Login,
  UserProfileSession,
  UserProfileSessionMicro,
  Manage,
  MealPreselectFlights,
  MenuPromotions,
  MybMigrationDocs,
  openModalLogin,
  openModalSignUp,
  modalLoginMethod,
  modalSignUpMethod,
  PantheonData,
  pendingOpenModalLogin,
  PersonalizedAcquisition,
  PopUpPersonalization,
  PriorityList,
  ProfileLogin,
  quoteRefund,
  reducerQuantityAdults,
  reducerQuantityInfants,
  reducerQuantityKids,
  refundCode96Dot5,
  refundGticketList,
  refundInfoToSalesforce,
  refundPassengerList,
  refundReason,
  ScheduleChange,
  SeatFare,
  SeatMapBanner,
  SessionValidation,
  singleBilling,
  stampingBilling,
  StoreFront,
  ToastReducer,
  TouchPointCpProperty,
  TouchPointsLogin,
  tokenInvalidSecurity,
  TravelInformation,
  UpgradeVoucher,
});
